export interface MenuItem {
  label: string;
  icon: string;
  route?: string;
  tooltip: string;
  roles: string[];
  children?: MenuItem[];
}

export const SIDEBAR_MENU: MenuItem[] = [
  {
    label: "Dashboard",
    icon: "pi pi-home",
    route: "/dashboard",
    tooltip: "Dashboard",
    roles: ["admin", "sales", "ba", "approver", "marketing"],
  },
   {
    label: "Performance Analytics",
    icon: "pi pi-chart-bar",
    route: "/performance-analytics",
    tooltip: "Performance Analytics",
    roles: ["admin"],
  },
  {
    label: "All Quotes",
    icon: "pi pi-wave-pulse",
    route: "/quotes",
    tooltip: "All Quotes",
    roles: ["admin", "sales", "ba", "approver", "marketing"],
  },
  {
    label: "Audit Logs",
    icon: "pi pi-shield",
    route: "/audit-logs",
    tooltip: "Audit Logs",
    roles: ["admin"],
  },
  {
    label: "Users Management",
    icon: "pi pi-users",
    route: "/users",
    tooltip: "Users Management",
    roles: ["admin"],
  },
  {
    label: "News",
    icon: "icon icon_news",
    route: "/news",
    tooltip: "News",
    roles: ["admin", "sales", "ba", "approver", "marketing"],
  },
  {
    label: "Settings",
    icon: "pi pi-cog",
    tooltip: "Settings",
    roles: ["admin", "sales", "ba", "approver", "marketing"],
    children: [
      {
        label: "General Settings",
        icon: "pi pi-cog",
        route: "/settings",
        tooltip: "General Settings",
        roles: ["admin","approver"],
      },
      {
        label: "Profile",
        icon: "pi pi-user",
        route: "/profile",
        tooltip: "Profile",
        roles: ["admin", "sales", "ba", "approver", "marketing"],
      },
    ],
  },
  {
    label: "Resource Library",
    icon: "pi pi-folder-open",
    route: "/resource-library",
    tooltip: "Resource Library",
    roles: ["admin"],
  },
];
